module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"walk_setting":"Walk Setting","duration":"Duration","wait":"Wait","easing":"easing","keep_fov":"Keep FOV","loop":"Loop"},"ja":{"walk_setting":"巡回設定","duration":"移動時間","wait":"静止時間","easing":"easing","keep_fov":"画角を保持","loop":"ループ"}}')
  delete Component.options._Ctor
}
